export default __webpack_public_path__ + "static/media/social-wall-bg.ac765554.png";